export class NotificationRetry {
    retryCount: number = 0;
    dateTimeToNextRetry: number = 0;
    retryMaxCount: number = 3;
}